import React, { useState } from 'react';
import { Reservation } from './resController';
import translate from '@data/translations';
import { ReservationStatus } from '@common/modelDefinition';
import { condoStatusCheck } from './utils';
import { BasicSRCSettingsButton } from './reservations/ActionsToolbar';
import useStore from '@data/state/zustand';
import ReservationGuestReference from './reservations/reservationGuestReference';
import dayjs from 'dayjs';
import { BoardEnum } from '@pages/posTerminal/sideMenu/boardConsumption';

interface CondoOwnerProps {
    history: any;
    reservation: Reservation;
    children: any;
}

const ReservationLinkTabs: any = {
    0: 'General',
    1: 'Guest info',
};

enum ReservationLinkTabsEnum {
    'general' = 0,
    'guestInfo' = 1,
}

function CondoOwnerRestrictionWrapper(props: CondoOwnerProps) {
    const { history, reservation, children } = props;
    const { isReservationMadeByOwner, isReservationMadeForOwner } = condoStatusCheck(reservation);
    const [activeTab, setActiveTab] = useState<ReservationLinkTabsEnum>(ReservationLinkTabsEnum.general);
    const otherSettings: any = useStore((appState: any) => appState.otherSettings);


    if (isReservationMadeForOwner) {
        return <div>{'isReservationMadeForOwner to do!!!!'}</div>;
    }

    const minibarConsumption = reservation.MinibarLogs
        ? reservation.MinibarLogs.filter((ml: any) => !ml.InvoiceItem)
        : [];

    if (isReservationMadeByOwner && minibarConsumption.length === 0) {
        return (
            <div className="text-center justify-content-center">
                <h3 className="text-center mt-5">{translate('Reservation managed by aparment owner!')}</h3>
                <p>
                    {translate('Reservation status')}: {translate(ReservationStatus[reservation.statusEnum])}
                </p>

                {reservation.statusEnum === ReservationStatus.checkedIn && (
                    <div className='ml-16p'>
                        <BasicSRCSettingsButton reservation={reservation} room={reservation.RoomInfo} />
                        {!reservation.guest1CodeCopy ? (
                            <div className="text-danger">
                                {translate('Room is NOT encoded with condo owner card code!')}
                            </div>
                        ) : null}
                    </div>
                )}

                {/* Tabs */}
                <div className="mt-4p">
                    <div className="reservation-form-tabs pl-8p pr-8p">
                        {Object.keys(ReservationLinkTabs)?.map((t: string, index: number) => {
                            return (
                                <div
                                    onClick={() => {
                                        if (reservation?.id) {
                                            setActiveTab(index);
                                        }
                                    }}
                                    className={
                                        'reservation-form-tabs-single' + (activeTab === index ? ' active-tab' : '')
                                    }
                                    style={{
                                        color: reservation?.id ? (activeTab === index ? '#0545a6' : 'black') : '',
                                    }}
                                    key={index}
                                >
                                    {translate(ReservationLinkTabs[t])}
                                </div>
                            );
                        })}
                    </div>

                    <div className="reservation-body-inner-wrapper">
                        {activeTab === ReservationLinkTabsEnum.general ? (
                            <GeneralTabContent reservation={reservation} otherSettings={otherSettings} />
                        ) : null}

                        {activeTab === ReservationLinkTabsEnum.guestInfo && reservation?.id !== undefined ? (
                            <ReservationGuestReference
                                history={history}
                                reservation={reservation}
                                otherSettings={otherSettings}
                            />
                        ) : null}
                    </div>
                </div>

                <br />
                <div className="display-flex justify-content-center mb-8p">
                    <button
                        className="button-primary"
                        onClick={() => {
                            history.push(`/checkoutAndInvoice/${reservation.id}`);
                        }}
                    >
                        {translate('Invoices')}
                    </button>
                </div>
            </div>
        );
    } else {
        return <React.Fragment>{children}</React.Fragment>;
    }
}

// General Tab - Sve poravnato levo
function GeneralTabContent(props: { reservation: Reservation; otherSettings: any }) {
    const { reservation, otherSettings } = props;

    // Ime holdera
    const holderName = reservation.Customer
        ? `${reservation.Customer.firstName} ${reservation.Customer.lastName}`
        : reservation.Company
        ? reservation.Company.name
        : translate('No holder assigned');

    // Board display value
    const boardValue = reservation.board ? translate(BoardEnum[reservation.board as keyof typeof BoardEnum]) : '-';

    return (
        <div className="">
            {/* Holder Name */}
            <div className="mt-4p mb-12p">
                <label className="text-bold mb-4p" style={{ display: 'block', textAlign: 'left' }}>
                    {translate('Holder name')}
                </label>
                <div
                    style={{
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                        borderRadius: '6px',
                        backgroundColor: '#fbfbfb',
                        padding: '12px 16px',
                        textAlign: 'left',
                    }}
                >
                    <div style={{ fontSize: '15px', fontWeight: '600', color: '#333' }}>{holderName}</div>
                    {reservation.Customer?.email && (
                        <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>
                            {reservation.Customer.email}
                        </div>
                    )}
                </div>
            </div>

            {/* Prijava / Odjava Row */}
            <div className="display-flex mobile-page-form" style={{ gap: '16px', marginTop: '16px' }}>
                <div className="flex">
                    <label className="text-bold mb-4p" style={{ display: 'block', textAlign: 'left' }}>
                        {translate('Check in')}:
                    </label>
                    <div className="display-flex" style={{ gap: '8px' }}>
                        <input
                            type="text"
                            className="input input-modal"
                            value={
                                reservation.checkInTimestamp
                                    ? dayjs(reservation.checkInTimestamp).format(
                                          otherSettings?.dateFormat || 'DD/MM/YYYY'
                                      )
                                    : ''
                            }
                            readOnly
                            style={{
                                backgroundColor: '#f8f9fa',
                                cursor: 'not-allowed',
                                width: '120px',
                                textAlign: 'left',
                            }}
                        />
                        <input
                            type="text"
                            className="input input-modal"
                            value={
                                reservation.checkInTimestamp
                                    ? dayjs(reservation.checkInTimestamp).format('HH:mm')
                                    : ''
                            }
                            readOnly
                            style={{
                                backgroundColor: '#f8f9fa',
                                cursor: 'not-allowed',
                                width: '80px',
                                textAlign: 'left',
                            }}
                        />
                    </div>
                </div>
                <div className="flex">
                    <label className="text-bold mb-4p" style={{ display: 'block', textAlign: 'left' }}>
                        {translate('Check out')}:
                    </label>
                    <div className="display-flex" style={{ gap: '8px' }}>
                        <input
                            type="text"
                            className="input input-modal"
                            value={
                                reservation.checkOutTimestamp
                                    ? dayjs(reservation.checkOutTimestamp).format(
                                          otherSettings?.dateFormat || 'DD/MM/YYYY'
                                      )
                                    : ''
                            }
                            readOnly
                            style={{
                                backgroundColor: '#f8f9fa',
                                cursor: 'not-allowed',
                                width: '120px',
                                textAlign: 'left',
                            }}
                        />
                        <input
                            type="text"
                            className="input input-modal"
                            value={
                                reservation.checkOutTimestamp
                                    ? dayjs(reservation.checkOutTimestamp).format('HH:mm')
                                    : ''
                            }
                            readOnly
                            style={{
                                backgroundColor: '#f8f9fa',
                                cursor: 'not-allowed',
                                width: '80px',
                                textAlign: 'left',
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* Odrasli / Djeca / Usluga Row */}
            <div className="display-flex mobile-page-form" style={{ gap: '16px', marginTop: "16px" }}>
                <div style={{ flex: '0 0 auto' }}>
                    <label className="text-bold mb-4p" style={{ display: 'block', textAlign: 'left' }}>
                        {translate('Adults')}:
                    </label>
                    <input
                        type="number"
                        className="input input-modal"
                        value={reservation.adultsNumber || 1}
                        readOnly
                        style={{
                            backgroundColor: '#f8f9fa',
                            cursor: 'not-allowed',
                            width: '80px',
                            textAlign: 'left',
                        }}
                    />
                </div>
                <div style={{ flex: '0 0 auto' }}>
                    <label className="text-bold mb-4p" style={{ display: 'block', textAlign: 'left' }}>
                        {translate('Children')}:
                    </label>
                    <input
                        type="number"
                        className="input input-modal"
                        value={reservation.childrenNumber || 0}
                        readOnly
                        style={{
                            backgroundColor: '#f8f9fa',
                            cursor: 'not-allowed',
                            width: '80px',
                            textAlign: 'left',
                        }}
                    />
                </div>
                <div style={{ flex: '0 0 auto' }}>
                    <label className="text-bold mb-4p" style={{ display: 'block', textAlign: 'left' }}>
                        {translate('Board')}:
                    </label>
                    <input
                        type="text"
                        className="input input-modal"
                        value={boardValue}
                        readOnly
                        style={{
                            backgroundColor: '#f8f9fa',
                            cursor: 'not-allowed',
                            minWidth: '150px',
                            textAlign: 'left',
                        }}
                    />
                </div>
            </div>
        </div>
    );
}

export default CondoOwnerRestrictionWrapper;